import React from "react";
import PropTypes from "prop-types";
import { Pagination as BootstrapPagination } from "react-bootstrap";

import { usePagination } from "../hooks/usePagination";

const Pagination = ({ totalPages, currentPage, siblingCount, baseUrl }) => {
    const { paginationRange, showLeftDots, showRightDots } = usePagination({
        totalCount: totalPages,
        currentPage,
        siblingCount,
    });

    if (totalPages === 1) {
        return null;
    }

    const lastPage = totalPages;

    return (
        <BootstrapPagination>
            <BootstrapPagination.Prev
                className="prev mx-1"
                disabled={currentPage === 1}
                href={`${baseUrl}/${currentPage - 1}/`}
            />
            <BootstrapPagination.Item
                key={1}
                href={`${baseUrl}/1/`}
                active={currentPage === 1}
            >
                1
            </BootstrapPagination.Item>
            {showLeftDots && <BootstrapPagination.Ellipsis disabled />}

            {paginationRange.map(page => (
                <BootstrapPagination.Item
                    className="mx-1"
                    key={page}
                    href={`${baseUrl}/${page}/`}
                    active={currentPage === page}
                >
                    {page}
                </BootstrapPagination.Item>
            ))}

            {showRightDots && <BootstrapPagination.Ellipsis disabled />}

            <BootstrapPagination.Item
                className="mx-1"
                key={lastPage}
                href={`${baseUrl}/${lastPage}/`}
                active={currentPage === lastPage}
            >
                {lastPage}
            </BootstrapPagination.Item>

            <BootstrapPagination.Next
                className="next mx-1"
                disabled={currentPage === lastPage}
                href={`${baseUrl}/${currentPage + 1}/`}
            />
        </BootstrapPagination>
    );
};

Pagination.propTypes = {
    totalPages: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    siblingCount: PropTypes.number,
    baseUrl: PropTypes.string.isRequired,
};

export default Pagination;
